export default __webpack_public_path__ + "static/media/leave-system-logo.b66a02f7.png";